/* winterburn: responsive hero graphics.
   <wb-gfx data-mode="mandelbulb" data-accent="#8fc3ff" data-warm="#ff6a55"><canvas></canvas></wb-gfx>
   It follows the pointer (mouse or touch), pause when off screen,
   and draw a single still frame for visitors who prefer reduced motion. */
(function () {
  if (customElements.get('wb-gfx')) return;

  function rgb(hex, f) {
    var m = /^#?([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i.exec((hex || '').trim());
    return m ? [parseInt(m[1], 16), parseInt(m[2], 16), parseInt(m[3], 16)] : f;
  }

  /* ================= MODES ================= */
  var MODES = {};

  /* ---- 1. Mandelbulb (WebGL raymarch) ---- */
  MODES.mandelbulb = {
    webgl: true,
    init: function (g) {
      var gl = g.canvas.getContext('webgl', { antialias: false, alpha: false, preserveDrawingBuffer: false });
      if (!gl) return false;
      g.gl = gl;
      var vs = 'attribute vec2 p;void main(){gl_Position=vec4(p,0.,1.);}';
      var fs = [
        'precision highp float;',
        'uniform vec2 R;uniform float T;uniform vec2 M;uniform vec3 A;uniform vec3 W;uniform vec2 O;uniform float S;uniform float Z;uniform float V;',
        'mat2 rot(float a){float c=cos(a),s=sin(a);return mat2(c,-s,s,c);}',
        'float DE(vec3 p,out float trap){vec3 z=p;float dr=1.;float r=0.;float pw=8.+sin(T*.05)*1.2;trap=1e9;',
        ' for(int i=0;i<6;i++){r=length(z);if(r>2.)break;',
        '  float th=acos(clamp(z.z/r,-1.,1.));float ph=atan(z.y,z.x);',
        '  dr=pow(r,pw-1.)*pw*dr+1.;float zr=pow(r,pw);th*=pw;ph*=pw;',
        '  z=zr*vec3(sin(th)*cos(ph),sin(ph)*sin(th),cos(th))+p;trap=min(trap,dot(z,z));}',
        ' return .5*log(r)*r/dr;}',
        'void main(){vec2 uv=(gl_FragCoord.xy-.5*R)/min(R.x,R.y);uv-=O;vec3 AC=mix(A,mix(W,A,smoothstep(-.3,.3,uv.y)),S);',
        ' vec3 ro=vec3(0.,0.,-3.35*Z);vec3 rd=normalize(vec3(uv*.9,1.));',
        ' float ay=-T*.025-M.x*.7;float ax=.35+M.y*.35;',
        ' ro.yz*=rot(ax);rd.yz*=rot(ax);ro.xz*=rot(ay);rd.xz*=rot(ay);',
        ' float t=0.;float trap=0.;float glow=0.;bool hit=false;float steps=0.;',
        ' for(int i=0;i<72;i++){vec3 p=ro+rd*t;float d=DE(p,trap);glow+=exp(-d*28.)*.02;',
        '  if(d<.0012*t){hit=true;break;}t+=d*.9;steps+=1.;if(t>5.)break;}',
        ' vec3 bg=vec3(.024,.027,.04);vec3 col=bg;',
        ' if(hit){vec3 p=ro+rd*t;float tt;vec2 e=vec2(.0015,-.0015);',
        '  vec3 n=normalize(e.xyy*DE(p+e.xyy,tt)+e.yyx*DE(p+e.yyx,tt)+e.yxy*DE(p+e.yxy,tt)+e.xxx*DE(p+e.xxx,tt));',
        '  float ao=pow(1.-steps/72.,1.6);float tr=clamp(sqrt(trap)*.55,0.,1.);',
        '  vec3 L=normalize(vec3(.6,.8,-.5));float dif=max(dot(n,L),0.);float rim=pow(1.-max(dot(n,-rd),0.),3.);',
        '  float spec=pow(max(dot(reflect(-L,n),-rd),0.),24.);',
        '  vec3 body=mix(vec3(.55,.58,.66),vec3(.3,.32,.4),tr);',
        '  col=body*(.12+.95*dif)*ao+AC*rim*.9*ao+vec3(1.)*spec*.35*ao+AC*pow(1.-tr,5.)*.6+W*smoothstep(.9,1.,tr)*.08*(1.-S);}',
        ' col+=AC*glow*.28;',
        ' col=mix(col,bg,smoothstep(.55,1.25,length(uv))*V);',
        ' gl_FragColor=vec4(pow(col,vec3(.9)),1.);}'
      ].join('\n');
      function sh(type, src) {
        var s = gl.createShader(type); gl.shaderSource(s, src); gl.compileShader(s);
        if (!gl.getShaderParameter(s, gl.COMPILE_STATUS)) { console.warn(gl.getShaderInfoLog(s)); return null; }
        return s;
      }
      var v = sh(gl.VERTEX_SHADER, vs), f = sh(gl.FRAGMENT_SHADER, fs);
      if (!v || !f) return false;
      var pr = gl.createProgram(); gl.attachShader(pr, v); gl.attachShader(pr, f); gl.linkProgram(pr);
      if (!gl.getProgramParameter(pr, gl.LINK_STATUS)) return false;
      gl.useProgram(pr);
      var b = gl.createBuffer(); gl.bindBuffer(gl.ARRAY_BUFFER, b);
      gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 3, -1, -1, 3]), gl.STATIC_DRAW);
      var loc = gl.getAttribLocation(pr, 'p'); gl.enableVertexAttribArray(loc); gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);
      g.u = { R: gl.getUniformLocation(pr, 'R'), T: gl.getUniformLocation(pr, 'T'), M: gl.getUniformLocation(pr, 'M'), A: gl.getUniformLocation(pr, 'A'), W: gl.getUniformLocation(pr, 'W'), O: gl.getUniformLocation(pr, 'O'), S: gl.getUniformLocation(pr, 'S'), Z: gl.getUniformLocation(pr, 'Z'), V: gl.getUniformLocation(pr, 'V') };
      gl.uniform1f(g.u.V, g.dataset.vignette === 'false' ? 0 : 1);
      gl.uniform1f(g.u.S, g.dataset.split === 'true' ? 1 : 0);
      gl.uniform1f(g.u.Z, parseFloat(g.dataset.zoom || '1'));
      gl.uniform3f(g.u.A, g.accent[0] / 255, g.accent[1] / 255, g.accent[2] / 255);
      gl.uniform3f(g.u.W, g.warm[0] / 255, g.warm[1] / 255, g.warm[2] / 255);
      return true;
    },
    scale: function (g) { return g.w < 750 ? 0.75 : 0.5; },
    resize: function (g) { g.gl.viewport(0, 0, g.canvas.width, g.canvas.height); },
    frame: function (g) {
      var gl = g.gl;
      gl.uniform2f(g.u.R, g.canvas.width, g.canvas.height);
      gl.uniform1f(g.u.T, g.t);
      gl.uniform2f(g.u.M, g.mx, g.my);
      var asp = g.w / g.h, centre = g.dataset.align === 'center';
      if (centre) gl.uniform2f(g.u.O, 0., asp < 0.8 ? 0.18 : 0.); else if (asp > 1.3) gl.uniform2f(g.u.O, 0.32, 0.); else if (asp < 0.8) gl.uniform2f(g.u.O, 0., 0.42); else gl.uniform2f(g.u.O, 0., 0.1);
      gl.drawArrays(gl.TRIANGLES, 0, 3);
    }
  };

  /* ================= ELEMENT ================= */
  class WbGfx extends HTMLElement {
    connectedCallback() {
      this.canvas = this.querySelector('canvas');
      if (!this.canvas) return;
      this.setMode(this.dataset.mode || 'mandelbulb');
    }

    setMode(name) {
      this.teardown();
      var fresh = document.createElement('canvas');
      this.canvas.replaceWith(fresh); this.canvas = fresh;
      this.mode = MODES[name] || MODES.mandelbulb;
      this.bg = rgb(this.dataset.bg, [6, 7, 10]);
      this.bgCss = 'rgb(' + this.bg.join(',') + ')';
      this.ink = rgb(this.dataset.ink, [228, 231, 236]);
      this.accent = rgb(this.dataset.accent, [143, 195, 255]);
      this.warm = rgb(this.dataset.warm, [255, 106, 85]);
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.t = Math.random() * 50; this.mx = 0; this.my = 0; this.tmx = 0; this.tmy = 0;
      this.visible = true;
      if (!this.mode.init(this)) { this.classList.add('is-failed'); return; }
      this.onResize = this.resize.bind(this);
      this.onMove = this.move.bind(this);
      this.loop = this.frame.bind(this);
      window.addEventListener('resize', this.onResize);
      var host = this.closest('.wb-hero, .wb-release-hero') || this.parentElement || this;
      this.host = host;
      host.addEventListener('pointermove', this.onMove, { passive: true });
      host.addEventListener('pointerdown', this.onMove, { passive: true });
      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver((e) => { this.visible = e[0].isIntersecting; if (this.visible) this.start(); });
        this.io.observe(this);
      }
      this.resize();
      this.px = this.w * 0.62; this.py = this.h * 0.45;
      this.classList.add('is-ready');
      if (this.reduced) { this.mode.frame(this); } else { this.start(); }
    }

    teardown() {
      cancelAnimationFrame(this.raf); this.running = false;
      if (this.onResize) window.removeEventListener('resize', this.onResize);
      if (this.host && this.onMove) { this.host.removeEventListener('pointermove', this.onMove); this.host.removeEventListener('pointerdown', this.onMove); }
      if (this.io) this.io.disconnect();
    }

    disconnectedCallback() { this.teardown(); }

    resize() {
      var r = this.getBoundingClientRect();
      this.w = Math.max(1, Math.floor(r.width)); this.h = Math.max(1, Math.floor(r.height));
      var dpr = Math.min(window.devicePixelRatio || 1, 1.5);
      var s = this.mode.scale ? this.mode.scale(this) : dpr;
      this.canvas.width = Math.floor(this.w * s); this.canvas.height = Math.floor(this.h * s);
      if (this.ctx) this.ctx.setTransform(s, 0, 0, s, 0, 0);
      this.mode.resize(this);
      if (this.reduced && this.mode.frame) this.mode.frame(this);
    }

    move(e) {
      var r = this.getBoundingClientRect();
      this.px = e.clientX - r.left; this.py = e.clientY - r.top;
      this.tmx = (this.px / this.w - 0.5) * 2; this.tmy = (this.py / this.h - 0.5) * 2;
    }

    start() {
      if (this.reduced || this.running) return;
      this.running = true; this.last = performance.now();
      this.raf = requestAnimationFrame(this.loop);
    }

    frame(now) {
      if (!this.visible || document.hidden) { this.running = false; return; }
      var dt = Math.min(0.05, (now - this.last) / 1000); this.last = now;
      this.t += dt;
      this.mx += (this.tmx - this.mx) * 0.018; this.my += (this.tmy - this.my) * 0.018;
      this.mode.frame(this);
      this.raf = requestAnimationFrame(this.loop);
    }
  }

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) document.querySelectorAll('wb-gfx').forEach(function (el) { el.start && el.start(); });
  });

  customElements.define('wb-gfx', WbGfx);
})();
